import React from 'react';
import {
  FaBox,
  FaFileAlt,
  FaListUl,
  FaSyncAlt,
  FaTimes,
} from 'react-icons/fa';
import { CLIENT_CATALOG } from '../../constant';

export default function ClientCatalogProductGrid({
  products,
  onTearSheet,
  onBOM,
  onProductCycle,
  onRemoveFromCatalog,
}) {
  return (
    <div className="products-grid">
      {products.map((product) => (
        <div key={product.uid} className="product-card">
          <div className="product-image-container">
            {product.images && product.images.length > 0 && product.images[0]?.path ? (
              <img
                src={product.images[0].path}
                alt={product.itemNo || 'Product'}
                className="product-image"
              />
            ) : (
              <div className="product-image-placeholder">
                <FaBox size={48} className="text-muted" />
              </div>
            )}
          </div>

          <div className="product-info">
            <div className="product-item-no">
              <strong>{CLIENT_CATALOG.ITEM_NO_LABEL}</strong>
              <span>{product.itemNo || CLIENT_CATALOG.NA}</span>
            </div>

            <div className="product-details d-flex justify-content-between align-items-center">
              <p className="product-category">{product?.productName || CLIENT_CATALOG.NA}</p>
              {product.color && product.color.length > 0 && (
                <p className="product-specs">
                  <span className="badge bg-secondary">
                    {CLIENT_CATALOG.COLOR_BADGE(product.color.length)}
                  </span>
                </p>
              )}
            </div>

            <div className="product-actions-main">
              <button
                type="button"
                className="btn btn-action-icon"
                onClick={(e) => onTearSheet(product, e)}
                title={CLIENT_CATALOG.TITLE_TEARSHEET}
                aria-label={CLIENT_CATALOG.TITLE_TEARSHEET}
              >
                <FaFileAlt size={14} aria-hidden />
              </button>
              <button
                type="button"
                className="btn btn-action-icon"
                onClick={(e) => onBOM(product, e)}
                title={CLIENT_CATALOG.TITLE_BOM}
              >
                <FaListUl size={14} />
              </button>
              <button
                type="button"
                className="btn btn-action-icon"
                onClick={(e) => onProductCycle(product, e)}
                title={CLIENT_CATALOG.TITLE_PRODUCT_CYCLE}
              >
                <FaSyncAlt size={14} />
              </button>
              <button
                type="button"
                className="btn btn-action btn-remove ms-auto"
                onClick={() => onRemoveFromCatalog(product.uid)}
                title={CLIENT_CATALOG.TITLE_REMOVE}
              >
                <FaTimes />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
